import React from "react";
import logo1x from "../../../assets/logo-1x.png";
import logo2x from "../../../assets/logo-2x.png";
import logo1xWebp from "../../../assets/logo-1x.webp";
import logo2xWebp from "../../../assets/logo-2x.webp";

const Logo = ({ className = "", href = `${window.location.origin}/nps-task/app/home` }) => {
  return (
    <div className={`inline-block ${className}`}>
      <a href={href} className="focus:outline-none" aria-label="NPS Task Portal Home">
        <picture>
          <source type="image/webp" srcSet={`${logo1xWebp} 1x, ${logo2xWebp} 2x`} />
          <img
            src={logo1x}
            srcSet={`${logo1x} 1x, ${logo2x} 2x`}
            alt="NPS Task Portal"
            loading="lazy"
            className="h-8 sm:h-10 md:h-12 lg:h-14 object-contain"
            style={{ maxWidth: "180px" }}
          />
        </picture>
      </a>
    </div>
  );
};

export default Logo;